export enum GridMenuActionType {
  ClearAllFilters,
  ResetColumnSelection,
  ResetColumnSizes,
  ResetPagination,
  ResetColumnOrder,
  ResetAllSettings,
  ShowCertifiedOnly,
}
